module.exports = __webpack_public_path__ + "static/home-search-form-front-1-5d2e59b1c830232a4cef7db9a7634adf.png";